import React, { useEffect, useRef, useState } from "react";
import { Collapse } from "antd";
import { useCanvas } from "../../context/canvasContext";
import './antSidebar.css';
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useDocument } from "../../context/documentInfoContex";

const { Panel } = Collapse;

const StickyNotesModal = ({ isStickyNotesModalVisible, setIsStickyNotesModalVisible, triggerButtonRef }) => {
  const isMobile = window.screen.width < 768;
  const { id } = useParams();
  const { createStickyNote, canvasRef } = useCanvas();
  const { setBoardData } = useDocument();
  const modalRef = useRef(null);

  const stickyNoteColors = [
    { name: "Yellow", color: "#FFEB3B" },
    { name: "Pink", color: "#F06292" },
    { name: "Blue", color: "#64B5F6" },
    { name: "Green", color: "#81C784" },
    { name: "Orange", color: "#FFB74D" },
  ];

  useEffect(() => {
    if (isStickyNotesModalVisible && triggerButtonRef?.current && modalRef?.current) {
      const buttonRect = triggerButtonRef.current.getBoundingClientRect();
      const modal = modalRef.current;
      const parentRect = triggerButtonRef.current.offsetParent.getBoundingClientRect();

      // Calculate position relative to the parent (toolbar)
      const offsetX = 10;
      const offsetY = isMobile ? 40 : 0;
      const newLeft = buttonRect.left - parentRect.left + buttonRect.width + offsetX;
      const newTop = isMobile
        ? buttonRect.top - parentRect.top + buttonRect.height + offsetY
        : buttonRect.top - parentRect.top;

      // Ensure modal stays within viewport
      const modalWidth = isMobile ? 155 : 168;
      const viewportWidth = window.innerWidth;
      const adjustedLeft = Math.min(newLeft, viewportWidth - modalWidth - 10);

      modal.style.position = 'absolute';
      modal.style.left = `${adjustedLeft + 40}px`;
      modal.style.top = `${newTop}px`;
      modal.style.zIndex = '10';

    }
  }, [isStickyNotesModalVisible, triggerButtonRef, isMobile]);


  const handleStickyNoteCreate = (color) => {
    createStickyNote(id, {
      width: 200,
      height: 150,
      backgroundColor: color,
      left: 100,
      top: 100,
      fontSize: 16,
    });
    setIsStickyNotesModalVisible(false);
    if (canvasRef?.current) {
      const canvasData = canvasRef.current.toJSON(["selectable", "id", "type"]);
      setBoardData(canvasData);
    } else {
      console.warn("canvasRef is not ready");
    }
  };

  if (!isStickyNotesModalVisible) {
    return null;
  }

  const handleCollapseChange = (key) => {
    if (key.length === 0) {
      setIsStickyNotesModalVisible(false);
    }
  };

  return (
    <div
      ref={modalRef}
      style={{
        width: isMobile ? '155px' : '168px',
        boxShadow: "rgb(101 92 92 / 50%) 0px 3px 8px",
        borderRadius: "5px",
      }}
    >
      <Collapse
        bordered={true}
        expandIconPosition="right"
        defaultActiveKey={['1']}
        onChange={handleCollapseChange}
      >
        <Panel
          style={{ fontSize: isMobile ? '11px' : '13px' }}
          header="Sticky Notes"
          key="1"
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', cursor: 'pointer' }}>
            {stickyNoteColors.map((note) => (
              <div
                key={note.name}
                onClick={() => handleStickyNoteCreate(note.color)}
                style={{
                  padding: '10px',
                  backgroundColor: note.color,
                  border: '1px solid #ccc',
                  borderRadius: '3px',
                  textAlign: 'center',
                  color: '#333',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                }}
              >
                {note.name}
              </div>
            ))}
          </div>
        </Panel>
      </Collapse>
    </div>
  );
};

export default StickyNotesModal;
